// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__zth34","loader":"Loader_loader__JRRf3"};